<template>
<el-select size="small" v-model="val" value-key="id" :placeholder="placeholder" class="f-w" filterable remote :remote-method="filterData" @change="change" clearable @clear="change">
    <el-option v-for="item in options" :key="item.id" :label="item.realName" :value="item.id" />
</el-select>
</template>

<script>
import api from "@/common/api"
import {
    mapGetters
} from "vuex";
export default {
    props: {
        value: Number,
        name: String,
        dept: String,
        autoUser: Boolean,
        placeholder: String
    },
    data() {
        return {
            val: this.value,
            staff: null,
            options: []
        }
    },
    computed: {
        ...mapGetters(["user"])
    },
    watch: {
        value() {
            if (this.autoUser && !this.value) {
                this.auto()
                return
            }
            this.val = this.value
            this.getStaffById()
        },
        val() {
            if (this.val != this.value) {
                this.$emit('input', this.val)
                this.$emit('update:name', this.staff.realName)
            }
        }
    },
    mounted() {
        this.auto()
    },
    methods: {
        change(id) {
            this.staff = this.options.find(item => item.id == id)
            this.$emit('change', id, this.staff)
        },
        filterData(keyword) {
            api.queryStaff({
                keyword: keyword,
                deptCode: this.dept,
                pageIndexOnView: 1,
                pageSize: 100
            }).then(res => {
                this.options = res.items
            })
        },
        getStaffById() {
            if (this.val) {
                api.getStaff(this.val).then(res => {
                    this.options = [res]
                })
            } else {
                api.queryStaff({
                    deptCode: this.dept,
                    pageIndexOnView: 1,
                    pageSize: 100
                }).then(res => {
                    this.options = res.items
                })
            }
        },
        auto() {
            if (this.autoUser && !this.value && this.user) {
                this.$emit('input', this.user.id)
                this.$emit('update:name', this.user.name)
                this.options = [{
                    id: this.user.id,
                    realName: this.user.name
                }]
            }
        }
    }
}
</script>
